import React, { useState } from "react";
import PageHeader from "../../core/common/header/PageHeader";
import {
  FaEye,
  FaExclamationTriangle,
  FaHistory,
  FaCalendarAlt,
} from "react-icons/fa";
import PendingPayments from "./PendingPayments";
import OverduePayments from "./OverduePayments";
import PaymentHistory from "./PaymentHistory";
import DueInstallments from "./DueInstallments";

type TabType = "review" | "overdue" | "history" | "due";

const AdminPaymentManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("review");

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <PageHeader
        icon={<FaCalendarAlt />}
        title="Payment Management"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Dashboard", to: "/admin/dashboard" },
          { label: "Payment Management" },
        ]}
      />

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm mb-6 border border-gray-200">
          <div className="flex border-b border-gray-200 overflow-x-auto">
            <button
              onClick={() => setActiveTab("review")}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors relative whitespace-nowrap ${
                activeTab === "review"
                  ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-orange-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <FaEye
                className={activeTab === "review" ? "text-orange-500" : ""}
              />
              In Review
            </button>
            <button
              onClick={() => setActiveTab("overdue")}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors relative whitespace-nowrap ${
                activeTab === "overdue"
                  ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-red-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <FaExclamationTriangle
                className={activeTab === "overdue" ? "text-red-500" : ""}
              />
              Overdue
            </button>
            <button
              onClick={() => setActiveTab("history")}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors relative whitespace-nowrap ${
                activeTab === "history"
                  ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-green-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <FaHistory
                className={activeTab === "history" ? "text-green-500" : ""}
              />
              Payment History
            </button>
            <button
              onClick={() => setActiveTab("due")}
              className={`flex items-center gap-2 px-6 py-4 font-medium transition-colors relative whitespace-nowrap ${
                activeTab === "due"
                  ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-yellow-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <FaCalendarAlt
                className={activeTab === "due" ? "text-yellow-500" : ""}
              />
              Due Installments
            </button>
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === "review" && <PendingPayments />}
        {activeTab === "overdue" && <OverduePayments />}
        {activeTab === "history" && <PaymentHistory />}
        {activeTab === "due" && <DueInstallments />}
      </main>
    </div>
  );
};

export default AdminPaymentManagement;
